import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { TableColumn } from 'src/app/reuseableui/tablelayout/tablelayout.component';

@Component({
  selector: 'app-schoolstudentlist',
  templateUrl: './schoolstudentlist.component.html',
  styleUrls: ['./schoolstudentlist.component.css'],
})
export class SchoolstudentlistComponent implements OnInit {
  students: any[] = [];
  columns: TableColumn[] = [];
  count = 0;
  filterOptions: any[];
  removeColumn = ['count', 'studentId'];
  noStudentText = 'No students enrolled';
  private courses: any[] = [];

  constructor(
    public schoolmanager: SchoolmanagementService,
    public toastr: ToastrService,
    public headerinfo: ComponentheaderService
  ) {
    headerinfo.setHeaderDisplay('School Students', [], []);
  }

  async ngOnInit() {
    const schdata: any = await this.schoolmanager.getSchoolFromSubdomain();
    this.headerinfo.setHeaderDisplay(
      'School Students',
      [
        { displaytext: schdata?.schoolName, route: '/user/schoolhome' },
        { displaytext: 'Students', route: '/user/schoolstudentlist' },
      ],
      []
    );
  }

  async loadTableData(eventData: any) {
    this.headerinfo.pageLoadingStarted(this);
    try {
      const data: any = await this.schoolmanager
        .getSchoolStudentsTable(eventData.page, eventData.offset, this.setFilterData(eventData), eventData.sortBy, eventData.sortAscending)
        .toPromise();
      this.students = data?.students ?? [];
      this.columns = data?.columns ?? [];
      this.count = this.students.length > 0 ? this.students[0].count : 0;
      this.courses = data?.courses ?? this.courses;
      // keep the table's own filter objects (they hold the current values) once built
      this.filterOptions = eventData.filters?.length > 0 ? eventData.filters : this.buildFilterOptions();
    }
    catch (e: any) {
      this.toastr.error(e?.error?.message ?? 'Could not load students');
    }
    finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  private setFilterData(eventData: any) {
    return (eventData?.filters ?? [])
      .filter((f: any) => f.value && (f.dropdown || f.search || f.date))
      .map((f: any) => ({ param: f.param, value: f.date ? this.toDateOnly(f.value) : '' + f.value }));
  }

  /** The picked calendar day as yyyy-mm-dd, so no timezone shift moves it a day. */
  private toDateOnly(value: any) {
    const d = new Date(value);
    const pad = (n: number) => ('' + n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  private buildFilterOptions() {
    return [
      { param: 'Search', search: true, label: 'Search' },
      { param: 'JoinedFrom', dropdown: false, date: true, label: 'Joined from' },
      { param: 'JoinedTo', dropdown: false, date: true, label: 'Joined to' },
      {
        param: 'Status', dropdown: true, date: false, label: 'Status',
        dropdownOptions: [
          { displaytext: 'All', value: '' },
          { displaytext: 'Active', value: 'active' },
          { displaytext: 'Inactive', value: 'inactive' },
        ],
      },
      {
        param: 'Course', dropdown: true, date: false, label: 'Course',
        dropdownOptions: [{ displaytext: 'All courses', value: '' }]
          .concat(this.courses.map(c => ({ displaytext: c.name, value: '' + c.id }))),
      },
    ];
  }
}
